import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";
import { BookedCourtsResponse } from "../apis/types";
import { CourtBookingApi } from "../apis/bookingapi";

export class MatchListStore {
  rootStore: RootStore;
  modalData?: {
    visible: boolean;
    title: string;
    children: string;
    btnText?: string;
    btnVariant?: string;
    onClose?: () => void;
    onAccept?: () => void;
    headerIcon?: React.ReactNode;
  };
  isLoading: boolean = false;
  matchList: BookedCourtsResponse[] = [];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  getMatchList = async () => {
    this.isLoading = true;
    try {
      const response = await CourtBookingApi.getBookingList();
      this.matchList = response;
    } catch (e) {
      this.modalData = {
        visible: true,
        title: "Error",
        children: "Something went wrong while getting match list",
        btnText: "Ok",
        onClose: () => {
          this.modalData = undefined;
        },
      };
    } finally {
      this.isLoading = false;
    }
  };

  deleteOrDropFromBooking = async (id: number, isCancel?: boolean) => {
    this.isLoading = true;
    try {
      isCancel
        ? await CourtBookingApi.deleteBooking(id)
        : await CourtBookingApi.dropFromBooking(id);
      this.getMatchList();
    } catch (e) {
      this.modalData = {
        visible: true,
        title: "Error",
        children: "Something went wrong while deleting booking",
        btnText: "Ok",
        onAccept: () => {
          this.modalData = undefined;
        },
      };
    } finally {
      this.isLoading = false;
    }
  };

  confirmForDeleteDropBooking = async (
    id: number,
    cancellationDescription?: string,
    isCancel?: boolean
  ) => {
    this.modalData = {
      visible: true,
      title: "Confirm",
      children: `Are you sure you want to ${
        isCancel ? "delete" : "drop from"
      } this booking?\n${cancellationDescription ?? ""}`,
      onClose: () => {
        this.modalData = undefined;
      },
      onAccept: () => {
        this.modalData = undefined;
        this.deleteOrDropFromBooking(id, isCancel);
      },
    };
  };
}
